module.exports = __webpack_public_path__ + "r-v3/img/minus_white.67870911.svg";